import styled from 'vue-styled-components'

const theme = {font: String}

const ThemedUserName = styled('section', theme)`
          font-family: "${props => (props.font === 'System') ? 'Montserrat' : props.font}";
          font-weight: bold;
          margin-top: 14px;
          margin-bottom: 6px;
          font-size: 16px;
          line-height: 24px;
          max-width: 153px;
          text-overflow: ellipsis;
          max-height: 63px;
          overflow: hidden;

          &.overflowed {
            position: relative;

            &::after {
              content: "";
              position: absolute;
              width: 100%;
              height: 16px;
              bottom: 0;
              left: 0;
              background: linear-gradient(
                  180deg,
                  rgba(248, 248, 248, 0) 0%,
                  #f8f8f8 83.98%
              );
            }
          }
`

export default ThemedUserName
